/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_CopyrightInputs */

const en_app_footer_copyright = /** @type {(inputs: App_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copyright © 2025, The Listening App LLC`)
};

const es_app_footer_copyright = /** @type {(inputs: App_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copyright © 2025, The Listening App LLC`)
};

/**
* | output |
* | --- |
* | "Copyright © 2025, The Listening App LLC" |
*
* @param {App_Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_copyright = /** @type {((inputs?: App_Footer_CopyrightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_CopyrightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_copyright(inputs)
	return en_app_footer_copyright(inputs)
});